// @flow

import React from 'react';

import { colors } from '../constants';
import styled from 'styled-components';
import { ForwardArrow } from '../icons';

type BreadCrumbLink = {
  label: string,
  url?: string,
};

export type BreadcrumbProps = {
  links: Array<BreadCrumbLink>,
  className?: string,
};

class BreadCrumbs extends React.PureComponent<BreadcrumbProps> {
  renderBreadCrumb(link: BreadCrumbLink, idx: number, linkCount: number) {
    const isCurrentPageLink = idx === linkCount - 1;

    // eslint-disable-next-line no-use-before-define
    const LinkComponent = link.url ? Link : PlaceholderLink;

    let props = {};

    if (link.url) {
      props.href = link.url;
    }

    if (isCurrentPageLink) {
      props['aria-current'] = 'page';
    }

    return (
      <BreadCrumb key={idx}>
        <LinkComponent {...props}>{link.label}</LinkComponent>
        {!isCurrentPageLink && (
          <ChevronSpacer>
            <ForwardArrow
              width="12px"
              height="12px"
              color={colors.mediumGrey}
            />
          </ChevronSpacer>
        )}
      </BreadCrumb>
    );
  }

  render() {
    const { links, className } = this.props;

    const breadCrumbElems = links.map((link, idx) => {
      return this.renderBreadCrumb(link, idx, links.length);
    });

    return (
      <nav aria-label="Breadcrumb" className={className}>
        <BreadCrumbList>{breadCrumbElems}</BreadCrumbList>
      </nav>
    );
  }
}

export default BreadCrumbs;

const BreadCrumbList = styled.ol`
  list-style: none;
  display: inline-block;
`;

/* $FlowFixMe This comment suppresses an error found when upgrading Flow to
 * v0.92.0. To view the error, delete this comment and run Flow. */
const BreadCrumb = styled.li`
  display: inline-block;
`;

const Link = styled.a`
  &:hover {
    text-decoration: none;
  }
`;

const ChevronSpacer = styled.div`
  display: inline-block;
  vertical-align: middle;
  padding: 0 5px;
`;

const PlaceholderLink = styled(Link)`
  color: ${colors.mediumGrey};
`;
